import { Grid } from "@material-ui/core";
import React from "react";

import DataGraphCard from "./DataGraphCard";

/**
 * DataGraphPageコンポーネント.
 *
 * @return {object} コンポーネント
 */
function DataGraphPage() {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <DataGraphCard />
      </Grid>
    </Grid>
  );
}

export default DataGraphPage;
